import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import classes from '../../../index.module.scss'

const Item = ({ isDisplayLevel, item, deleteItem }) => {
  const handleDelete = () => deleteItem(item.id)

  return (
    <Element style={{ color: '#3a414b' }} className={classes.item}>
      <div className={classes.level}>
        {isDisplayLevel && (
          <div
            className={classes.text}
            style={{ backgroundColor: isDisplayLevel ? '#F3F3F3' : '' }}
          >
            <Translate value="settingPreferences.LEVEL" />
            {item.level}
          </div>
        )}
      </div>
      <div className={classes.code}>{item.code}</div>
      <div className={classes.name}>{item.name}</div>
      <div className={classes.border}>
        <Element style={{ backgroundColor: '#d5d5d5' }} />
      </div>
      <Element className={classes.delete}>
        <Icon
          onClick={handleDelete}
          className="icon-delete-circle-fill"
          style={{ color: '#9c9c9c', fontSize: 16 }}
        />
      </Element>
    </Element>
  )
}

Item.propTypes = {
  isDisplayLevel: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired,
  deleteItem: PropTypes.func.isRequired,
}

export default Item
